import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(stroke => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
  viewBox: "3 2 42 42"
}, /*#__PURE__*/React.createElement("path", {
  stroke: stroke,
  d: "M38 38H10V10h14V6H10c-2 0-4 2-4 4v28c0 2 2 4 4 4h28c2 0 4-2 4-4v-14h-4v14zM28 6v4h7l-20 20 3 3L38 13V20h4V6h-14z"
}))), 'Launch');